import { render, staticRenderFns } from "./modified.vue?vue&type=template&id=97c75748&"
import script from "./modified.vue?vue&type=script&lang=js&"
export * from "./modified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports